// jQueryを使用してイベントを設定
$(document).ready(function() {
  initializeYoutuberTags();
  initializeTagInput();
  initializeLivePreview();
  initializeDeleteModal();
});

$(document).on('turbolinks:load', function() {
  initializeYoutuberTags();
  initializeTagInput();
  initializeLivePreview();
  initializePreviewButton();
  initializeShowEditPreview();
  initializeDeleteModal();
});

function initializeLivePreview() {
  
  // Thumbnail preview
  $('#profile_image_file_input').on('change', function() {
    const file = this.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = function(e) {
        // Update both desktop and mobile preview
        $('#thumbnail-preview').html(`<img src="${e.target.result}" class="preview-image object-fit">`);
        $('#thumbnail-preview-mobile').html(`<img src="${e.target.result}" class="preview-image object-fit">`);
        $('.youtuber-avatar-image').text(file.name);
        $('.profile_youtuber_image_preview').attr('src', e.target.result);
        
        // Show avatar preview in form
        $('#preview-image').attr('src', e.target.result);
        $('#avatar-preview').show();
      };
      reader.readAsDataURL(file);
    }
    // Clear profile image error when file is selected
    $('.error-hotel-profile-image').addClass('d-none');
    $(this).removeClass('invalid');
  });
  
  // YouTube link preview
  $('#youtuber_url').on('input', function() {
    const url = $(this).val();
    if (url) {
      $('#youtube-link-preview').html(`YouTube: <a href="${url}" class="youtube-link" target="_blank">${url}</a>`);
      $('#youtube-link-preview-mobile').html(`YouTube: <a href="${url}" class="youtube-link" target="_blank">${url}</a>`);
    } else {
      $('#youtube-link-preview').html('YouTube: <a href="#" class="youtube-link">https://www.youtube.com</a>');
      $('#youtube-link-preview-mobile').html('YouTube: <a href="#" class="youtube-link">https://www.youtube.com</a>');
    }
    // Update preview content
    updatePreviewContent();
    // Clear YouTube URL error when user types valid URL
    if (url.trim() && isValidYouTubeUrl(url.trim())) {
      $('.error-youtuber-url').addClass('d-none');
      $('.error-youtuber-url').text('※YouTubeのURLを入力してください');
      $(this).removeClass('invalid');
    }
  });
  
  // Description preview
  $('#youtuber_description').on('input', function() {
    const description = $(this).val();
    if (description) {
      $('#description-preview').text(description);
      $('#description-preview-mobile').text(description);
    } else {
      $('#description-preview').text('YouTubeの動画を投稿しています。');
      $('#description-preview-mobile').text('YouTubeの動画を投稿しています。');
    }
    // Update preview content
    updatePreviewContent();
    // Clear description error when user types
    if (description.trim()) {
      $('.error-hotel-note').addClass('d-none');
      $(this).removeClass('invalid');
    }
  });
  
  // Category preview
  $('#pet-category-select').on('change', function() {
    updateCategoryPreview();
    updateCategoryTags();
    updateTagsPreview();
    updatePreviewContent();
    // Clear category error when user selects
    if ($(this).val()) {
      $('.error-category').addClass('d-none');
      $(this).removeClass('invalid');
    }
  });
  
  $('#pet-subcategory-select').on('change', function() {
    updateCategoryPreview();
    updateCategoryTags();
    updateTagsPreview();
    updatePreviewContent();
    // Clear subcategory error when user selects
    if ($(this).val()) {
      $('.error-sub-category').addClass('d-none');
      $(this).removeClass('invalid');
    }
  });
  
  // Initialize preview on page load
  updateCategoryPreview();
  updateCategoryTags();
  updateTagsPreview();
  
  // Initialize avatar preview for edit mode
  initializeAvatarPreview();
  
  // Checkbox validation
  $('input[name="youtuber[is_published]"]').on('change', function() {
    // Clear checkbox error when user checks
    if ($(this).is(':checked')) {
      $('.error-checkbox').addClass('d-none');
      $(this).removeClass('invalid');
    }
  });

  // Add real-time error clearing for all form fields
  $(document).on('input change', '#youtuber_url', function() {
    const url = $(this).val().trim();
    if (url && isValidYouTubeUrl(url)) {
      $('.error-youtuber-url').addClass('d-none');
      $(this).removeClass('invalid');
    }
  });

  $(document).on('input', '#youtuber_description', function() {
    const description = $(this).val().trim();
    if (description) {
      $('.error-hotel-note').addClass('d-none');
      $(this).removeClass('invalid');
    }
  });

  $(document).on('change', '#pet-category-select', function() {
    if ($(this).val()) {
      $('.error-category').addClass('d-none');
      $(this).removeClass('invalid');
    }
  });

  $(document).on('change', '#pet-subcategory-select', function() {
    if ($(this).val()) {
      $('.error-sub-category').addClass('d-none');
      $(this).removeClass('invalid');
    }
  });

  $(document).on('change', '#profile_image_file_input', function() {
    const file = this.files[0];
    const existingImage = $('.existing-image').attr('src');
    
    // Clear error if file is selected OR if there's a valid existing image
    const hasFile = file && file.size > 0;
    const hasValidExistingImage = existingImage && existingImage.length > 0;
    
    if (hasFile || hasValidExistingImage) {
      $('.error-hotel-profile-image').addClass('d-none');
      $(this).removeClass('invalid');
    }
  });

  $(document).on('change', 'input[name="youtuber[is_published]"]', function() {
    if ($(this).is(':checked')) {
      $('.error-checkbox').addClass('d-none');
      $(this).removeClass('invalid');
    }
  });
}

function updateCategoryPreview() {
  const categoryText = $('#pet-category-select option:selected').text();
  const subcategoryText = $('#pet-subcategory-select option:selected').text();
  
  let categoryDisplay = '';
  if (categoryText && categoryText !== '大分類を選んでください') {
    categoryDisplay += categoryText;
  }
  if (subcategoryText && subcategoryText !== '中分類を選んでください') {
    if (categoryDisplay) categoryDisplay += ' > ';
    categoryDisplay += subcategoryText;
  }
  
  // You can add category display to preview if needed
}

function updateCategoryTags() {
  // Remove existing category tags from form display
  $('.category-tag').remove();
  
  // Note: Category tags will only show in preview, not in the form
  // This function is kept for potential future use but doesn't add tags to form
}

function updateTagsPreview() {
  // Update preview tags in both desktop and mobile preview
  const tagsPreview = $('#tags-preview');
  const tagsPreviewMobile = $('#tags-preview-mobile');
  
  // Clear both previews
  tagsPreview.empty();
  tagsPreviewMobile.empty();
  
  // Add category tags (orange color) - from category/subcategory dropdowns
  const categoryText = $('#pet-category-select option:selected').text();
  const subcategoryText = $('#pet-subcategory-select option:selected').text();
  
  if (categoryText && categoryText !== '大分類を選んでください') {
    tagsPreview.append(`<div class="tag-item category-preview-tag">${categoryText}</div>`);
    tagsPreviewMobile.append(`<div class="tag-item category-preview-tag">${categoryText}</div>`);
  }
  
  if (subcategoryText && subcategoryText !== '中分類を選んでください') {
    tagsPreview.append(`<div class="tag-item category-preview-tag">${subcategoryText}</div>`);
    tagsPreviewMobile.append(`<div class="tag-item category-preview-tag">${subcategoryText}</div>`);
  }
  
  // Add selected global tags (gray color) - only from selected-tag elements
  $('.selected-tag').each(function() {
    const tagText = $(this).text().replace('×', '').trim();
    if (tagText) {
      tagsPreview.append(`<div class="tag-item global-preview-tag">${tagText}</div>`);
      tagsPreviewMobile.append(`<div class="tag-item global-preview-tag">${tagText}</div>`);
    }
  });
  
  // Add custom tags (gray color) - only from custom-tags-display container
  $('.custom-tags-display .custom-tag').each(function() {
    const tagText = $(this).text().replace('×', '').trim();
    if (tagText) {
      tagsPreview.append(`<div class="tag-item custom-preview-tag">${tagText}</div>`);
      tagsPreviewMobile.append(`<div class="tag-item custom-preview-tag">${tagText}</div>`);
    }
  });
  
  // Add default tags if no tags selected
  if ($('.selected-tag, .custom-tag').length === 0 && 
      (!categoryText || categoryText === '大分類を選んでください') && 
      (!subcategoryText || subcategoryText === '中分類を選んでください')) {
    tagsPreview.append('<div class="tag-item">おもちゃ</div>');
    tagsPreviewMobile.append('<div class="tag-item">おもちゃ</div>');
  }
}

function initializeYoutuberTags() {
  
  // 既存のイベントリスナーを削除
  $('.tag-button').off('click');
  
  // Tag selection functionality
  $('.tag-button').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    
    const checkbox = $('#' + $(this).attr('for'));
    const tagId = checkbox.val();
    const tagName = $(this).text().trim();
    
    
    if (checkbox.is(':checked')) {
      // Unselect tag
      checkbox.prop('checked', false);
      $(this).removeClass('selected');
      removeSelectedTag(tagId);
    } else {
      // Select tag
      checkbox.prop('checked', true);
      $(this).addClass('selected');
      addSelectedTag(tagId, tagName);
    }
  });
  
  // Initialize selected tags on page load
  $('.tag-checkbox:checked').each(function() {
    const tagId = $(this).val();
    const tagName = $(`label[for="tag_${tagId}"]`).text().trim();
    addSelectedTag(tagId, tagName);
  });
}

function initializeTagInput() {
  
  // タグ入力フィールドのイベント
  $('#tag-input').off('keydown keypress').on('keydown', function(e) {
    if (e.which === 13 || e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      
      const tagText = $(this).val().trim();
      
      if (tagText.length > 0 && tagText.length <= 20) {
        addCustomTag(tagText);
        $(this).val(''); // 入力フィールドをクリア
      } else if (tagText.length > 20) {
        alert('タグは最大20文字まで入力できます。');
      }
      return false;
    }
  });
}

// Helper function to create tag element
function createTagElement(tagText, tagId = null, isCustom = false) {
  const dataAttr = isCustom ? `data-tag-text="${tagText}"` : `data-tag-id="${tagId}"`;
  const buttonData = isCustom ? `data-tag-text="${tagText}"` : `data-tag-id="${tagId}"`;
  
  return $(`
    <span class="${isCustom ? 'custom-tag' : 'selected-tag'}" ${dataAttr}>
      ${tagText}
      <button type="button" class="remove-tag-btn" ${buttonData}>×</button>
    </span>
  `);
}

// Add selected tag to display
function addSelectedTag(tagId, tagName) {
  const existingTag = $('.selected-tags-display').find(`[data-tag-id="${tagId}"]`);
  if (existingTag.length === 0) {
    const tagElement = createTagElement(tagName, tagId, false);
    
    // Add remove functionality
    tagElement.find('.remove-tag-btn').on('click', function() {
      const tagId = $(this).data('tag-id');
      const checkbox = $(`#tag_${tagId}`);
      const button = $(`label[for="tag_${tagId}"]`);
      
      checkbox.prop('checked', false);
      button.removeClass('selected');
      removeSelectedTag(tagId);
    });
    
    $('.selected-tags-display').append(tagElement);
    updateTagsPreview(); // Update preview when tag is added
    updatePreviewContent(); // Update preview content
  }
}

// Remove selected tag from display
function removeSelectedTag(tagId) {
  // Remove from display
  $(`.selected-tag[data-tag-id="${tagId}"]`).remove();
  
  // Remove from form submission by unchecking the checkbox
  const checkbox = $(`#tag_${tagId}`);
  checkbox.prop('checked', false);
  
  // Remove selected class from button
  const button = $(`label[for="tag_${tagId}"]`);
  button.removeClass('selected');
  
  updateTagsPreview(); // Update preview when tag is removed
  updatePreviewContent(); // Update preview content
}

// Add custom tag to display
function addCustomTag(tagText) {
  const existingTag = $('.custom-tags-display').find(`[data-tag-text="${tagText}"]`);
  if (existingTag.length === 0) {
    const tagElement = createTagElement(tagText, null, true);
    
    // Add remove functionality
    tagElement.find('.remove-tag-btn').on('click', function() {
      const tagText = $(this).data('tag-text');
      removeCustomTag(tagText);
    });
    
    $('.custom-tags-display').append(tagElement);
    
    // Create hidden input for form submission
    const hiddenInput = $(`<input type="hidden" name="youtuber[custom_tags][]" value="${tagText}">`);
    $('form').append(hiddenInput);
    
    updateTagsPreview(); // Update preview when custom tag is added
    updatePreviewContent(); // Update preview content
  }
}

// Remove custom tag from display
function removeCustomTag(tagText) {
  $(`.custom-tag[data-tag-text="${tagText}"]`).remove();
  
  // Remove hidden input for form submission
  $(`input[name="youtuber[custom_tags][]"][value="${tagText}"]`).remove();
  
  updateTagsPreview(); // Update preview when custom tag is removed
  updatePreviewContent(); // Update preview content
}

// Initialize preview button functionality
function initializePreviewButton() {
  // Preview button (show preview)
  $('.btn-preview-youtuber').on('click', function(e) {
    e.preventDefault();
    
    
    // Validate required fields
    if (!validateRequiredFields()) {
      return false;
    }
    
    
    // Update preview content with form data
    updatePreviewContent();
    
    // Check if on mobile
    if (window.innerWidth < 768) {
      // On mobile, hide form and show final preview
      $('.create-youtuber').addClass('d-none');
      $('.preview-youtuber').removeClass('d-none');
      
      // Hide mobile tab preview (preview-youtuber-live-stream-mb)
      $('.preview-youtuber-live-stream-mb').css('display', 'none');
      
      // Hide mobile tab switching
      $('.tab-switch-container').addClass('d-none');
      
      // Hide form buttons and show preview buttons
      $('.form-buttons').addClass('d-none');
      $('.preview-buttons').removeClass('d-none');
    } else {
      // On desktop, use existing logic
      $('.create-youtuber').addClass('d-none');
      $('.preview-youtuber').removeClass('d-none');
      
      // Hide form buttons and show preview buttons
      $('.form-buttons').addClass('d-none');
      $('.preview-buttons').removeClass('d-none');
    }
    
    $('.preview-youtuber-title').removeClass('d-none');
    $('.create-youtuber-title').addClass('d-none');

    $('html, body').animate({
      scrollTop: 0
    }, 500);

  });
  
  // Back button (return to form)
  $('.btn-back-youtuber').on('click', function(e) {
    e.preventDefault();
    
    // Show form and hide preview
    $('.create-youtuber').removeClass('d-none');
    $('.preview-youtuber').addClass('d-none');
    
    // Check if on mobile
    if (window.innerWidth < 768) {
      // On mobile, hide tab preview and show form
      $('.preview-youtuber-live-stream-mb').css('display', 'none');
      $('.create-youtuber').css('display', 'block');
      
      // Reset tab buttons to form tab
      $('.tab-switch-btn[data-tab="form"]').addClass('active');
      $('.tab-switch-btn[data-tab="preview"]').removeClass('active');
      
      // On mobile, show tab switching again
      $('.tab-switch-container').removeClass('d-none');
    }
    
    // Show form buttons and hide preview buttons
    $('.form-buttons').removeClass('d-none');
    $('.preview-buttons').addClass('d-none');
    
    $('.create-youtuber-title').removeClass('d-none');
    $('.preview-youtuber-title').addClass('d-none');
  });
  
  // Submit button (submit form)
  $('.btn-submit-youtuber').on('click', function(e) {
    e.preventDefault();
    
    // Validate required fields again before submit
    if (!validateRequiredFields()) {
      return false;
    }
    
    // Submit the form directly without triggering events
    const form = $('form')[0];
    if (form) {
      form.submit();
    }
  });
}

// Validate required fields
function validateRequiredFields() {
  let isValid = true;
  
  // Clear all previous errors
  $('.owner-error').addClass('d-none');
  $('.form-control').removeClass('invalid');
  
  // Validate profile image - check if file is selected OR if existing image exists (for edit mode)
  const profileImage = $('#profile_image_file_input')[0];
  const existingImage = $('.existing-image').attr('src');
  
  
  // Check if no file is selected AND no valid existing image
  const hasFile = profileImage && profileImage.files && profileImage.files.length > 0;
  const hasValidExistingImage = existingImage && existingImage.length > 0;
  
  
  if (!hasFile && !hasValidExistingImage) {
    $('.error-hotel-profile-image').removeClass('d-none');
    $('#profile_image_file_input').addClass('invalid');
    isValid = false;
  } else {
  }
  
  // Validate YouTube URL
  const youtubeUrl = $('#youtuber_url').val().trim();
  if (!youtubeUrl) {
    $('.error-youtuber-url').removeClass('d-none');
    $('#youtuber_url').addClass('invalid');
    isValid = false;
  } else if (!isValidYouTubeUrl(youtubeUrl)) {
    $('.error-youtuber-url').removeClass('d-none');
    $('.error-youtuber-url').text('※有効なYouTubeリンクを入力してください');
    $('#youtuber_url').addClass('invalid');
    isValid = false;
  }
  
  // Validate category
  const categoryId = $('#pet-category-select').val();
  if (!categoryId) {
    $('.error-category').removeClass('d-none');
    $('#pet-category-select').addClass('invalid');
    isValid = false;
  }
  
  // Validate subcategory
  const subcategoryId = $('#pet-subcategory-select').val();
  if (!subcategoryId) {
    $('.error-sub-category').removeClass('d-none');
    $('#pet-subcategory-select').addClass('invalid');
    isValid = false;
  }
  
  // Validate description
  const description = $('#youtuber_description').val().trim();
  if (!description) {
    $('.error-hotel-note').removeClass('d-none');
    $('#youtuber_description').addClass('invalid');
    isValid = false;
  }
  
  const isPublished = $('input[name="youtuber[is_published]"]').is(':checked');
  if (!isPublished) {
    $('.error-checkbox').removeClass('d-none');
    $('input[name="youtuber[is_published]"]').addClass('invalid');
    isValid = false;
  }
  
  // Scroll to first error if validation fails
  if (!isValid) {
    $('html, body').animate({
      scrollTop: $('.owner-error:not(.d-none)').first().offset().top - 100
    }, 500);
  } else {
  }
  
  return isValid;
}

// Validate YouTube URL format
function isValidYouTubeUrl(url) {
  // Simple check: just verify it's a YouTube link
  return url.includes('youtube.com') || url.includes('youtu.be');
}

function updatePreviewContent() {
  const avatarPreview = $('.profile_youtuber_image_preview');
  if (avatarPreview.attr('src')) {
    $('.youtuber-image-preview').html(avatarPreview.clone());
  }
  
  const youtubeUrl = $('#youtuber_url').val();
  $('.preview-youtuber-title').eq(1).html(youtubeUrl || '未入力');
  
  const categoryText = $('#pet-category-select option:selected').text();
  const subcategoryText = $('#pet-subcategory-select option:selected').text();
  
  let categoryTags = '';
  if (categoryText && categoryText !== '大分類を選んでください') {
    categoryTags += `<span class="preview-tag category-tag">${categoryText}</span>`;
  }
  if (subcategoryText && subcategoryText !== '中分類を選んでください') {
    categoryTags += `<span class="preview-tag category-tag">${subcategoryText}</span>`;
  }
  $('.preview-youtuber-category').html(categoryTags || '未選択');
  
  // Update tags helper function
  function updateTagsPreview(selector, tags, defaultText) {
    let tagsHtml = '';
    tags.forEach(tag => {
      tagsHtml += `<span class="preview-tag-2">${tag}</span>`;
    });
    $(selector).html(tagsHtml || defaultText);
  }
  
  // Update global tags - only from checked checkboxes
  const globalTags = [];
  $('.tag-checkbox:checked').each(function() {
    const tagId = $(this).val();
    const tagName = $(`label[for="tag_${tagId}"]`).text().trim();
    if (tagName) {
      globalTags.push(tagName);
    }
  });
  updateTagsPreview('.preview-youtuber-tag-global', globalTags, '未選択');
  
  // Update custom tags - only from custom-tags-display container
  const customTags = [];
  $('.custom-tags-display .custom-tag').each(function() {
    const tagText = $(this).text().replace('×', '').trim();
    if (tagText) {
      customTags.push(tagText);
    }
  });
  updateTagsPreview('.preview-youtuber-tag-custom', customTags, '未入力');
  
  // Update description in preview button section only
  const description = $('#youtuber_description').val();
  $('.preview-youtuber-description').text(description || '未入力');
}

// Initialize preview content for show/edit mode
function initializeShowEditPreview() {
  if (window.location.pathname.includes('/show') || window.location.pathname.includes('/edit')) {
    // For edit mode, show the form (not preview) with existing data
    if (window.location.pathname.includes('/edit')) {
      // Show form and hide preview for edit mode
      $('.create-youtuber').removeClass('d-none');
      $('.preview-youtuber').addClass('d-none');
      $('.form-buttons, .form-buttons-mobile').removeClass('d-none');
      $('.preview-buttons, .preview-buttons-mobile').addClass('d-none');
      
      // Initialize existing data in the form
      initializeExistingData();
    } else if (window.location.pathname.includes('/show')) {
      // For show mode, show preview only
      $('.create-youtuber').addClass('d-none');
      $('.preview-youtuber').removeClass('d-none');
      $('.form-buttons, .form-buttons-mobile').addClass('d-none');
      $('.preview-buttons, .preview-buttons-mobile').removeClass('d-none');
      
      // Update preview content with existing data
      updatePreviewContent();
      updateTagsPreview();
    }
  }
}

// Initialize existing data in edit mode
function initializeExistingData() {
  // Clear existing selected tags display first to avoid duplicates
  $('.selected-tags-display').empty();
  
  // Initialize selected tags from existing data
  $('.tag-checkbox:checked').each(function() {
    const tagId = $(this).val();
    const tagName = $(`label[for="tag_${tagId}"]`).text().trim();
    addSelectedTag(tagId, tagName);
  });
  
  // Initialize custom tags from existing data and add remove functionality
  $('.custom-tags-display .custom-tag').each(function() {
    const tagText = $(this).text().replace('×', '').trim();
    if (tagText) {
      // Create hidden input for form submission if not exists
      if ($(`input[name="youtuber[custom_tags][]"][value="${tagText}"]`).length === 0) {
        const hiddenInput = $(`<input type="hidden" name="youtuber[custom_tags][]" value="${tagText}">`);
        $('form').append(hiddenInput);
      }
      
      // Add remove functionality to existing custom tags
      $(this).find('.remove-tag-btn').off('click').on('click', function() {
        const tagText = $(this).data('tag-text');
        removeCustomTag(tagText);
      });
    }
  });
  
  // Add remove functionality to existing selected tags
  $('.selected-tag').each(function() {
    $(this).find('.remove-tag-btn').off('click').on('click', function() {
      const tagId = $(this).data('tag-id');
      const checkbox = $(`#tag_${tagId}`);
      const button = $(`label[for="tag_${tagId}"]`);
      
      checkbox.prop('checked', false);
      button.removeClass('selected');
      removeSelectedTag(tagId);
    });
  });
  
  // Update live preview with existing data
  updateTagsPreview();
  updatePreviewContent();
  
  // Initialize category preview
  updateCategoryPreview();
  updateCategoryTags();
}

// Function to update mobile preview when switching to preview tab
function updateMobilePreview() {
  // Update thumbnail
  const fileInput = document.querySelector('input[name="youtuber[avatar]"]');
  const mobileThumbnail = document.getElementById('thumbnail-preview-mobile');
  
  if (fileInput && fileInput.files && fileInput.files[0]) {
    const reader = new FileReader();
    reader.onload = function(e) {
      if (mobileThumbnail) {
        mobileThumbnail.innerHTML = `<img src="${e.target.result}" class="preview-image object-fit">`;
      }
    };
    reader.readAsDataURL(fileInput.files[0]);
  } else {
    // Use existing image if available
    const existingImg = document.querySelector('.youtuber-avatar-preview img');
    if (existingImg && existingImg.src && mobileThumbnail) {
      mobileThumbnail.innerHTML = `<img src="${existingImg.src}" class="preview-image object-fit">`;
    }
  }
  
  // Update description
  const description = $('#youtuber_description').val();
  if (description) {
    $('#description-preview-mobile').text(description);
  } else {
    $('#description-preview-mobile').text('YouTubeの動画を投稿しています。');
  }
  
  // Update YouTube link
  const url = $('#youtuber_url').val();
  if (url) {
    $('#youtube-link-preview-mobile').html(`YouTube: <a href="${url}" class="youtube-link" target="_blank">${url}</a>`);
  } else {
    $('#youtube-link-preview-mobile').html('YouTube: <a href="#" class="youtube-link">https://www.youtube.com</a>');
  }
  
  // Update tags
  updateTagsPreview();
}

// Initialize delete confirmation modal
function initializeDeleteModal() {
  let deleteUrl = '';
  
  // When delete button is clicked, store the URL
  $('[data-bs-target="#deleteYoutuberModal"]').on('click', function() {
    deleteUrl = $(this).data('youtuber-url');
  });
  
  // When confirm button is clicked, proceed with deletion
  $('#confirmDeleteBtn').on('click', function() {
    if (deleteUrl) {
      // Create a form to submit DELETE request
      const form = $('<form>', {
        method: 'POST',
        action: deleteUrl
      });
      
      // Add CSRF token
      const csrfToken = $('meta[name="csrf-token"]').attr('content');
      form.append($('<input>', {
        type: 'hidden',
        name: 'authenticity_token',
        value: csrfToken
      }));
      
      // Add method override for DELETE
      form.append($('<input>', {
        type: 'hidden',
        name: '_method',
        value: 'DELETE'
      }));
      
      // Submit the form
      $('body').append(form);
      form.submit();
    }
  });
}

function initializeAvatarPreview() {
  const previewContainer = $('#avatar-preview');
  const previewImage = $('#preview-image');
  
  const existingImage = $('.existing-image').attr('src');
  
  if (existingImage && existingImage.length > 0) {
    previewImage.attr('src', existingImage);
    previewContainer.show();
  }
} 